import { useTranslations } from 'next-intl'

import Button, {
  ButtonTypes,
  ButtonVariants,
} from '~/components/atoms/Button/Button'
import type { ImageProps } from '~/components/atoms/Image/Image'
import Image from '~/components/atoms/Image/Image'
import Link from '~/components/atoms/Link/Link'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { useAuthV2 } from '~/contexts/AuthContext'

import styles from './ReportSignupIntro.module.css'

interface ReportSignupIntroProps {
  image: ImageProps
}

const ReportSignupIntro = ({ image }: ReportSignupIntroProps) => {
  const t = useTranslations()
  const { showAuthDialog } = useAuthV2()

  const handleSignUpClick = (e: any) => {
    e.preventDefault()
    showAuthDialog('', true, false, true, false, undefined)
  }

  const handleLoginClick = (e: any) => {
    e.preventDefault()
    showAuthDialog('', true, true, true, false, undefined)
  }

  return (
    <div className={styles.base}>
      <div className={styles.inner}>
        <Text
          size={TextSizes.primaryTitleLrg}
          Tag="h4"
          className={styles.title}
        >
          Data-driven art market reports
        </Text>
        <Text size={TextSizes.bodyMed} Tag="p">
          Becoming a member is always free, and also gives you access to market
          data and articles, you just need to sign up and verify your account.
        </Text>
        <div className={styles.cta}>
          <Button
            fullWidth
            iconLeft
            variant={ButtonVariants.primaryLight}
            button={{ onClick: handleSignUpClick, type: ButtonTypes.button }}
          >
            Sign up for free
          </Button>
          <Text Tag="p" size={TextSizes.bodySml} className={styles.loginText}>
            {t('auth.alreadyHaveAccount')}{' '}
            <a href="/login" onClick={handleLoginClick}>
              {t('auth.login')}
            </a>
          </Text>
        </div>
        <Text size={TextSizes.bodySml} Tag="p">
          {t('common.dataPrivacyStatement')}{' '}
          <Link href="/privacy" target="_blank" className={styles.link}>
            {t('navigation.privacyPolicy')}
          </Link>{' '}
          |{' '}
          <strong
            dangerouslySetInnerHTML={{
              __html: t('common.copyrightText', {
                year: new Date().getFullYear(),
              }),
            }}
          />
        </Text>
        <div className={styles.media}>
          {image && (
            <Image
              asset={image.asset}
              layout="responsive"
              sizes="500px"
              alt="Signup image"
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default ReportSignupIntro
